import { DatePipe } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormControl, UntypedFormBuilder, Validators } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { ConfirmationService, MessageService } from 'primeng/api'
import { environment } from '../../../../../environments/environment'
import { ExportDocuments } from '../../../../api/models/export-documents'
import { ExportDocumentsService } from '../../../../api/services/export-documents.service'

import { DocumentExport, ExportFileInfo, UiPreferences } from '../../../../api/models'
import { AppSettingService, DocumentService, ImageService } from '../../../../api/services'
import { Subject, combineLatest, interval, startWith, switchMap, takeUntil, timeoutWith, timer } from 'rxjs'
import { CareFinitySession } from '../../../services/CareFinitySession'
import { SelectedPatientService } from '../patient-list/patient-service'
import { validateAllFormFields } from '../../../../formUtils'



@Component({
    selector: 'app-export-document',
    templateUrl: './export-document.component.html',
    styleUrls: ['./export-document.component.scss'],
})
export class ExportDocumentComponent implements OnInit, OnDestroy {
    Item = 'Export Clinical Data'
    datefrom: Date
    dateto: Date
    Lastpageindex: number = 1
    rows: number
    _selectedColumns: any[]
    displaypopup: boolean = false
    private cols: any[]
    private localcols: any[]
    yearRangeForDatePicker: string
    pdfSrc: any
    href: string
    visible: boolean

    emrDocumentsList: ExportDocuments[]
    localDocumentsList: DocumentExport[]
    selectedItems: any[] = null
    showRecordsEmrDocs: boolean = false
    showRecordsLocal: boolean = false
    rowsEmrDocs: number
    rowsLocal: number
    first: number = 0 // Variable to control the paginator

    showExportCCDA: boolean = false
  //  preferences: UiPreferences = {};

    private destroy = new Subject<void>();

    preferencesmap: { [key: string]: string | null } | null = null;

    commentDialog = false;
    commentDialog_ccda= false;
    comment = new FormControl(null);
    showComment = false;
    commentText: any;
    // Categories for the multi-select dropdown
    categories: { label: string; value: string }[] = [];

    // Selected category keys (bound to p-multiSelect)
    selectedCategories: string[] = [];

    // Placeholder for preferences loaded from localStorage
    preferences: { [key: string]: string } = {};

    // String to store selected category keys joined by `#`
    selectedPatientTypes: string = '';
    isDisabled: boolean = false;

    isDisableDocument: boolean = false;

    exportMessage: string = '';

    messageMappings = {

        "0": "In Progress",
        "1": "completed",
        "2":"error"

    }

    documentExportStatus:any= {};

    displaypopupDetails: boolean = false;
    mseeage: string = '';
    constructor(
        private fb: UntypedFormBuilder,
        private router: Router,
        private expdocservice: ExportDocumentsService,
        public activatedRoute: ActivatedRoute,
        private datePipe: DatePipe,
        private messageService: MessageService,
        private docService: DocumentService,
        private selectedPatientService: SelectedPatientService,
        private appSettingsService: AppSettingService,
        private confirmation: ConfirmationService,
        private imageService: ImageService
    ) { }
    ngOnDestroy(): void {
        this.destroy.next();
    }

    ngOnInit() {
        this.yearRangeForDatePicker = environment.yearRangeForDatePicker

        this.cols = [
            { field: 'visitDate', header: 'Visit Date' },
            { field: 'description', header: 'Description' },
            { field: 'format', header: 'Format' },
            { field: 'itemType', header: 'Type' },
        ]
        this.localcols = [
            { field: 'documentExportDate', header: 'Export Date' },
            { field: 'exportDetails', header: 'Export Clinical Data' },
            { field: 'exportType', header: 'Export Type' },
            { field: 'role', header: 'Created By' },
            { field: 'status', header: 'Export Document Status' },
        ]

        this.loadPreferences();
        this.initializeCategories();
       // this.initializeSelectionState();

        this.emrDocumentList(1, '', '', '')

        // this.showExportCCDA = CareFinitySession.applicationSettings.applicationFeatures.showExportCCDA;

        this.showExportCCDA = CareFinitySession.practiceSettings.showExportCCDA;



        const storedPreferences = localStorage.getItem('uiPreferences');
        if (storedPreferences) {
            this.preferences = JSON.parse(storedPreferences);

            this.Item = this.preferences?.exportDocuments || 'Export Clinical Data';
        }

        interval(10 * 1000).pipe(
            switchMap(_ => this.expdocservice.exportDocumentsGetPendingDocuments({

                PatientID: sessionStorage.getItem('ptId'),
                PracticeId: localStorage.getItem('EmrPracticeId'),
            })),
            takeUntil(this.destroy)
        ).subscribe(data => {
            this.localDocumentsList = data.map(this.convertStringDataToJsonArray);
        })
    }

    getfiltered() {
        if (this.datefrom == null || this.dateto == null) {
            this.messageService.add({
                key: 'alertToast',
                severity: 'error',
                detail: 'Invalid  date, a valid date is required',
                summary: 'ERROR',
                life: 5000,
            })
            return
        }
        this.emrDocumentList(
            1,
            '',
            this.datePipe.transform(this.datefrom, environment.dateformat),
            this.datePipe.transform(this.dateto, environment.dateformat),true
        )
    }
    clearfilters() {
        this.dateto = null
        this.datefrom = null
        this.emrDocumentList(1, '', '', '')
        this.selectedItems = [];
        this.selectedPatientTypes = null;
    }

    Restoredocuments() {

        //if (this.comment.invalid)
        //{
        //        validateAllFormFields(this.comment);
        //        return;
        //}            

        const filesToExport = (this.selectedItems ?? [])
            .filter(item => item) // Remove null/undefined items
            .map(value => ({
                id: value.fileName,
                fileFormat: value.format,
                dbIndic: value.databaseIndic,
                itemType: value.itemType,
                imagetype: value.imageType,
                fileType: value.fileType,
                fileDescription: value.description,
                visitDate: value.visitDate,
                location: value.location
            }));
        this.confirmation.confirm({
            key: 'delete_confirmation',
            header: 'Export Confirmation',
            message: 'Export has started and will be available shortly.',
            acceptLabel: 'OK',
            rejectVisible: false,
            accept: () => {
                this.expdocservice
                    .exportDocumentsExportDocumentsDetail({
                        body: {
                            comment: this.comment.value,
                            filesToExport: filesToExport.length > 0 ? filesToExport : []
                        },
                            patientId: sessionStorage.getItem('ptId'),
                        practiceId: localStorage.getItem('EmrPracticeId'),
                        patientName: sessionStorage.getItem('ptName'),
                        selectedPatientDataTypes: this.selectedPatientTypes
                    })
                    .subscribe((resp) => {
                        this.resetPage()
                        this.emrDocumentList(1, '', '', '')

                        this.commentDialog = false;
                        this.comment.reset();

                        this.clearfilters();
                        })
                },
            })

            //  need to call action for lab doc
        
    }

    formatExportMessage(): void {
        const preferencesMap: { [key: string]: string } = {
            documents: 'Documents & Images',
            problems: 'Problems',
            allergies: 'Allergies',
            medications: 'Medications',
            visits: 'Visits',
            labs: 'Labs',
            orders: 'Orders',
            vitals: 'Vitals',
        };

        if (Array.isArray(this.selectedCategories) && this.selectedCategories.length > 0) {
            // Map selected categories to their corresponding labels
            const formattedCategories = this.selectedCategories
                .map((category) => this.preferences[category] || preferencesMap[category])
                .join(', ');

            // Create the export message
            this.exportMessage = `Export of the following data: ${formattedCategories} has started and will be available shortly.`;
        } else {
            console.error('No valid selected categories to export.');
        }
    }

    ccdaDocuments()
    {

        

        this.commentDialog_ccda = true;

       
    }


    Restoredocuments_CCDA() {


       
        var querystring = '';
        var params = ''
        //this.confirmation.confirm({
        //    key: 'delete_confirmation',
        //    header: 'Export CCDA Confirmation',
        //    message: 'Are you sure to export CCDA?',
        //    acceptLabel: 'OK',
        //    rejectVisible: false,
        //    accept: () =>
        //    {

        //        this.expdocservice
        //            .exportDocumentsGetExportCcda$Response({
        //                patientId: sessionStorage.getItem('ptId'),
        //                PracticeId: localStorage.getItem('EmrPracticeId'),
        //                comments: this.comment.value
        //            })
        //            .subscribe((resp) => {
        //                this.resetPage()
        //                this.emrDocumentList(1, '', '', '');

        //                this.commentDialog_ccda = false;
        //                this.comment.reset();
        //                this.clearfilters();
        //            })
        //    },
        //})


        this.confirmation.confirm({
            key: 'delete_confirmation',
            header: 'Export CCDA Confirmation',
            message: 'Are you sure you want to export the CCDA?',           
            acceptLabel: 'OK',
            rejectLabel: 'Cancel',        // Optional: Label for Cancel
            rejectVisible: true,          // Show the Cancel button
            accept: () => {
                this.expdocservice
                    .exportDocumentsGetExportCcda$Response({
                        patientId: sessionStorage.getItem('ptId'),
                        PracticeId: localStorage.getItem('EmrPracticeId'),
                        comments: this.comment.value
                    })
                    .subscribe((resp) => {
                        this.resetPage();
                        this.emrDocumentList(1, '', '', '');

                        this.commentDialog_ccda = false;
                        this.comment.reset();
                        this.clearfilters();
                    });
            },
            reject: () => {
                // Optional: Do something when user cancels
                console.log('User cancelled CCDA export');
                this.commentDialog_ccda = false;
                this.comment.reset();
            }
        });

    }

    emrDocumentList(pageNumber: number, sortbydirection: string, datefrom: string, dateto: string, makeResultPreselected = false)
    {
        this.expdocservice
            .exportDocumentsGetDocumentList({
                page: 1,
                PatientID: sessionStorage.getItem('ptId'),
                PracticeId: localStorage.getItem('EmrPracticeId'),
                DateFrom: datefrom,
                dateTo: dateto,
            })
            .subscribe((result) => {
                this.emrDocumentsList = result.emrDocuments
                this.localDocumentsList = result.localexportedDocuments.map(i=> this.convertStringDataToJsonArray(i))
                this.rowsEmrDocs = result.pageSize
                this.rowsLocal = result.pageSize

                if (this.emrDocumentsList?.length > 0) {
                    this.showRecordsEmrDocs = true
                } else {
                    this.showRecordsEmrDocs = false
                }

                if (this.localDocumentsList?.length > 0) {
                    this.showRecordsLocal = true
                } else {
                    this.showRecordsLocal = false
                }

                if (makeResultPreselected===true) {

                    this.selectedItems = result.emrDocuments;
                }
            })
    }

    viewDoc(rowData: any) {

        if (rowData.exportType == 'CCDA') {
            this.messageService.add({
                key: 'alertToast',
                summary: "Download has started, Please wait till it is completed successfully.",
                severity: "success"

            });
            this.expdocservice
                .exportDocumentsDownloadFile({
                    Id: rowData.documentExportName,
                })
                .subscribe((blob) => {
                    console.log('downloaded file is ', blob)

                    const url = window.URL.createObjectURL(blob)
                    const a = document.createElement('a')
                    a.href = url
                    a.download = 'CCDA.xml'
                    a.click()
                    window.URL.revokeObjectURL(url)
                    this.messageService.add({
                        key: 'alertToast',
                        summary: "Download Completed.",
                        severity: "success"

                    });
                })
        } else {
            this.expdocservice
                .exportDocumentsDetail({
                    Id: rowData.documentExportId,
                })
                .subscribe((documentDetails) => {
                    this.docService
                        .documentGetDocuments({
                            fn: documentDetails.docName,
                            PatientName: sessionStorage.getItem('ptName'),
                        })
                        .subscribe((file) => {
                            if (documentDetails.flexPaper) {
                                this.router.navigate(['show-pdf'], {
                                    relativeTo: this.activatedRoute,
                                    state: {
                                        pdf: file,
                                        showPrintButton: CareFinitySession?.practiceSettings?.enablePatientDemographicPrint && CareFinitySession?.user?.roles?.patientRecordsPrint,
                                        enabledDocumentDownloads: CareFinitySession?.practiceSettings?.enableDocumentDownloads && CareFinitySession?.user?.roles?.enableDocumentDownloads

                                    },
                                })
                            } else {
                                const binaryData = [file]
                                const downloadLink = document.createElement('a')
                                downloadLink.href = window.URL.createObjectURL(
                                    new Blob(binaryData, { type: file.type }),
                                )
                                downloadLink.target = '_blank'
                                downloadLink.setAttribute('inline', 'arshid')
                                document.body.appendChild(downloadLink)
                                downloadLink.click()
                                document.body.removeChild(downloadLink) // Clean up

                            }
                        })
                })
        }
    }

    formatdatetime(item, type) {
        if (item != null && type.indexOf('Date') > -1) {
            return this.datePipe.transform(item, environment.datetimeformat)
        }
        return item
    }

    back() {

        this.router.navigate(["Patient/exportdocuments/list"]);
    }

    resetPage() {
        this.first = 0 // Set the paginator to the first page
        this.selectedItems = []
        this.initializeCategories();
    }

    viewDocUnMerged(rowData: any) {

        debugger;
        console.log("Data");
        console.log(rowData);
        let obs;
        if (rowData.itemType === "I") {

            obs = this.imageService.imageDetail({
                DocumentType: rowData.imageType,
                InDataBase: rowData.databaseIndic,
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
                Id: rowData.fileName,
                FileType: rowData.fileType,
                UserId: CareFinitySession.user.userID.toString(),


            }).pipe(timeoutWith(10 * 1000, this.imageService.imageDetail({
                DocumentType: rowData.imageType,
                InDataBase: rowData.databaseIndic,
                patientId: sessionStorage.getItem('ptId'),
                emrpracticeId: localStorage.getItem('EmrPracticeId'),
                Id: rowData.fileName,
                FileType: rowData.fileType,
                UserId: CareFinitySession.user.userID.toString(),


            })));
        } else {
            obs = this.docService
                .documentDetail({
                    Id: rowData.fileName,
                    Description: rowData.description,
                    DBIndic: rowData.databaseIndic,
                    fileFormat: rowData.format,
                    DocumentType: rowData.fileType,
                    Location: rowData.location,
                    VisitDate: rowData.visitDate,
                    PracticeId: localStorage.getItem('EmrPracticeId'),
                    PatientId: this.selectedPatientService.getPatientValue().patientId,
                    AddWaterMarkIfEnabled: false
                }).pipe(timeoutWith(10 * 1000, this.docService
                    .documentDetail({
                        Id: rowData.fileName,
                        Description: rowData.description,
                        DBIndic: rowData.databaseIndic,
                        fileFormat: rowData.format,
                        DocumentType: rowData.fileType,
                        Location: rowData.location,
                        VisitDate: rowData.visitDate,
                        PracticeId: localStorage.getItem('EmrPracticeId'),
                        PatientId: this.selectedPatientService.getPatientValue().patientId,
                        AddWaterMarkIfEnabled: false

                    })))

        }
        obs
            .subscribe((docementDetails) => {
                this.docService
                    .documentGetDocuments({
                        fn: docementDetails.docName || docementDetails.selectedPDF,
                        PatientName: sessionStorage.getItem('ptName'),
                    })
                    .subscribe(
                        (file) => {
                            if (docementDetails.flexPaper) {
                                this.router.navigate(['show-pdf'], {
                                    relativeTo: this.activatedRoute,
                                    state: {
                                        pdf: file,
                                        showPrintButton: CareFinitySession?.practiceSettings?.enablePatientDemographicPrint && CareFinitySession?.user?.roles?.patientRecordsPrint,
                                        enabledDocumentDownloads: CareFinitySession?.practiceSettings?.enableDocumentDownloads && CareFinitySession?.user?.roles?.enableDocumentDownloads


                                    },
                                })
                            } else {
                                let dataType = file.type
                                let binaryData = []
                                binaryData.push(file)
                                let downloadLink = document.createElement('a')
                                downloadLink.href = window.URL.createObjectURL(
                                    new Blob(binaryData, { type: dataType }),
                                )

                                this.href = downloadLink.href
                                this.visible = true
                                downloadLink.target = '_blank'
                                downloadLink.setAttribute('inline', 'arshid')
                                document.body.appendChild(downloadLink)
                                downloadLink.click()
                            }
                        },
                        (err) =>
                            this.messageService.add({
                                key: 'alertToast',
                                severity: 'error',
                                summary: 'ERROR',
                                detail:
                                    'Document File missing, Please Contact Technical Support',
                            }),
                    )
                console.log(docementDetails)
            })
    }





     // #region :: EXPORT CLINICAL PATIENT DATA FUNCTIONALITY :: 05-01-25
    // Load preferences from localStorage
   
    loadPreferences(): void
    {
        const storedPreferences = localStorage.getItem('uiPreferences');
        if (storedPreferences) {
            this.preferences = JSON.parse(storedPreferences);
        }
    }    
    //initializeCategories(): void {
    //    const preferencesMap: { [key: string]: string } = {
    //         problems: 'Problems',
    //         allergies: 'Allergies',
    //         medications: 'Medications',
    //         visits: 'Visits',
    //         labs: 'Labs',
    //         orders: 'Orders',
    //         vitals: 'Vitals',
    //         documents: 'Documents & Images',
    //    };

    //    this.preferences = this.preferences || {};
    //    this.categories = Object.keys(preferencesMap).map((key) => ({
    //        label: this.preferences?.[key] || preferencesMap[key],
    //        value: key,
    //    }));
    //    this.selectedCategories = ['documents'];
    //}





    

    initializeCategories(): void {
        debugger;
        const preferencesMap: { [key: string]: string } = {
            problems: 'Problems',
            allergies: 'Allergies',
            medications: 'Medications',
            visits: 'Visits',
            labs: 'Labs',
            orders: 'Orders',
            vitals: 'Vitals',
            documents: 'Documents & Images'
        };

        this.preferences = this.preferences || {};
        const roles = CareFinitySession?.user?.roles || {};

        console.log(roles);

        const normalizeKey = (key: string): string => {
            return key.toLowerCase().replace(/s$/, '');
            // removes trailing 's' for singular/plural match
        };

        this.categories = Object.keys(preferencesMap)
            .filter(key => {
                // Always include documents & images
                if (key === 'documents' || key === 'images') {
                    return true;
                }

                // Normalize both key and role keys for comparison
                const normalizedKey = normalizeKey(key);
                const roleMatch = Object.keys(roles).some(roleKey => normalizeKey(roleKey) === normalizedKey && roles[roleKey] === true);

                return roleMatch;
            })
            .map(key => ({
                label: this.preferences?.[key] || preferencesMap[key],
                value: key,
            }));

        // Default selected category
        this.selectedCategories = ['documents'];
    }



    toggleCategorySelection(): void {
           
        this.selectedPatientTypes = this.selectedCategories.join('#');
        console.log('Selected Categories:', this.selectedPatientTypes);
        // Check if 'documents' is part of the selected categories
        if (this.selectedCategories.includes('documents'))
        {
            //alert("true");
            this.selectedItems = null;
            this.isDisableDocument = false;
        } else {
          //  alert("false");
            this.selectedItems = null;
            this.isDisableDocument = true; 
        }
    }
    askForComment()
    {
   


        if (this.selectedCategories.includes("documents")) {
            if (this.selectedItems == null || this.selectedItems.length == 0) {
                this.messageService.add({
                    key: 'alertToast',
                    severity: 'error',
                    detail: 'Please select Documents !',
                    summary: 'ERROR',
                    life: 5000,
                })
                return;
            }
        }
       
        this.commentDialog = true;
        this.comment.reset();

    }
  
    showCommentDialog(rowData) {
        console.log(rowData)
        this.commentText = rowData.comment;
        this.showComment = true;
    }

    // #endregion'

    convertStringDataToJsonArray(exportedDocument: DocumentExport)
    {
       // alert(exportedDocument.status);
     //   alert(exportedDocument);
        return { ...exportedDocument, clinicalDataExportStatus: exportedDocument.clinicalDataExportStatusAsString ? JSON.parse(exportedDocument.clinicalDataExportStatusAsString) : [] };

       

    }

    viewClinicalConversionDetails(documentExportStatus: any)
    {

        this.displaypopupDetails = true;
        this.documentExportStatus = documentExportStatus;
        console.log(documentExportStatus)
        
    }    
    getStatusText(status: any): string
    {
        if (status == "1") {
            this.mseeage = "with error";
        }
        const statusMap: { [key: string]: string } = {

            "0": "In progress",
            "1": "completed",
            "2": "error"

        };
        return statusMap[status] || "Unknown";
    }
    getStatusBadgeClass(status: any): string
    {   
        if (status =="2") {
            this.mseeage = "with error";
        }
        
        const statusClassMap: { [key: string]: string } =
        {
            "0": "p-badge p-badge-info",   
            "1": "p-badge p-badge-success", 
            "2": "p-badge p-badge-danger"  
        };
        return statusClassMap[status] || "p-badge p-badge-secondary";
    }


    getstartusWithErro(aa: any[])
    {
        const hasError = aa.some(item => item.ClinicalDataStatus === 2);

        if (hasError) {
            console.error("Error: ClinicalDataStatus is 1");
            return "with error"; // You can change this return value as needed
        }

      

       

    }

    getFailedFiles() {

        console.log(this.documentExportStatus)
        if (this.documentExportStatus) {

            var values = this.documentExportStatus.fileConversionInfo?.split(/\${1}|\${2,}/).filter(i=> !!i).map(i => i.split(",")).flatMap(j => ({ description: j[0], visitDate: j[1] }))
            console.log(values);
            return values;
        }
        return [];
    }
    
}
